import axios from 'axios';
import Service from '@advisor/util/Service';
// eslint-disable-next-line import/no-cycle
import {generateServiceProxyOptions} from '@advisor/util/advisorUtils';

const {MS_BASE} = Service;

export default class ManageFirm {
  /** ***************************** Manage Firm Api start ***************************************************************** */
  /**
   * This will fetch firm information based on firmId
   * @param {firmId} payload
   */
  static getFirmInfo({riaId}) {
    const defaults = {
      baseUrl: MS_BASE,
    };

    const {baseUrl, options} = generateServiceProxyOptions(defaults, true);

    return axios.get(`${baseUrl}/v1/advisor/riaFirm/${riaId}`, options);
  }

  static updateFirmInfo(payload) {
    return axios.post(`${MS_BASE}/v1/advisor/riaFirm/${payload.riaId}`, payload);
  }

  static updateOfficeInfo(payload) {
    return axios.post(`${MS_BASE}/v1/advisor/riaFirmOffice?riaId=${payload.riaId}`, payload);
  }

  static getCustodianList(payload) {
    return axios.get(`${MS_BASE}/v1/custodian/custodianAccounts/count?riaId=${payload.riaId}`);
  }

  static getTDRepCodes(payload) {
    return axios.get(`${MS_BASE}/v1/custodian/${payload.custodianId}/repcode?riaId=${payload.riaId}`);
  }

  static saveTDRepCodes(payload) {
    return axios.post(
      `${MS_BASE}/v1/custodian/${payload.custodianId}/repcode?riaId=${payload.riaId}&riaUserId=${payload.riaUserId}`,
      payload.repcodes
    );
  }

  static updateTDRepCodes(payload) {
    return axios.put(`${MS_BASE}/v1/custodian/${payload.custodianId}/repcode?riaId=${payload.riaId}`, payload.repCodes);
  }
}
